import { EntityType, TaskType } from "~/common/enums";
import { AppEntity, AppExtEntity, UnionAppEntity } from "~/normalizr/entities";
import { entityThumbnails } from "./consts";
import { ThumbnailData, ThumbnailDataItem } from "./types";

export const getItemTypeFromTaskType = (item: ThumbnailDataItem): UnionAppEntity => {
    switch (item.TaskType) {
        case TaskType.Task:
            return AppEntity.Task;
        case TaskType.Issue:
            return AppEntity.Issue;
        case TaskType.Request:
            return AppEntity.Request;
    }
};
export const getItemTypeFromItem = (item: ThumbnailDataItem): UnionAppEntity => {
    switch (item.EntityType) {
        case EntityType.Project:
            return AppEntity.Project;
        case EntityType.Portfolio:
            return AppEntity.Portfolio;
        case EntityType.CustomField:
            return AppExtEntity.CustomField;
    }

    if (item.IsMilestone) {
        return AppExtEntity.Milestone;
    }

    if (item.TaskType) {
        return getItemTypeFromTaskType(item);
    }

    return;
};
export const getThumbnailDataByType = (item: ThumbnailDataItem): ThumbnailData => {
    const itemType = getItemTypeFromItem(item);

    return itemType ? entityThumbnails[itemType] : undefined;
};
